/* ===== NORTE SOUVENIR — SHOPIFY THEME JS ===== */

document.addEventListener('DOMContentLoaded', function () {

  // --- スクロールトップボタン ---
  const scrollTopBtn = document.querySelector('.js-scroll-top');
  if (scrollTopBtn) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 400) {
        scrollTopBtn.classList.add('is-visible');
      } else {
        scrollTopBtn.classList.remove('is-visible');
      }
    });
    scrollTopBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // --- モバイルメニュー ---
  const menuToggle = document.querySelector('.js-hamburger');
  const mobileNav = document.querySelector('.js-mobile-menu');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      mobileNav.setAttribute('aria-hidden', !isOpen);
    });
  }

  // --- 商品ギャラリー サムネイル切り替え ---
  const galleryThumbs = document.querySelectorAll('.gallery-thumb');
  const galleryMainImg = document.getElementById('gallery-main-img');
  if (galleryThumbs.length && galleryMainImg) {
    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        galleryThumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        galleryMainImg.src = thumb.dataset.src;
        galleryMainImg.alt = thumb.dataset.alt;
      });
    });
  }

  // --- 商品バリアント選択 ---
  const optionBtns = document.querySelectorAll('.option-value-btn');
  optionBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const index = btn.dataset.optionIndex;
      document.querySelectorAll('[data-option-index="' + index + '"]').forEach(function (b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
      updateVariant();
    });
  });

  function updateVariant() {
    // バリアントIDの更新（Shopifyのvariant_jsonを使う場合はここで処理）
    // 簡易実装：選択中のオプション値を収集してvariant IDを特定
    const selectedValues = [];
    const optionGroups = document.querySelectorAll('.product-option');
    optionGroups.forEach(function (group) {
      const activeBtn = group.querySelector('.option-value-btn.active');
      if (activeBtn) selectedValues.push(activeBtn.dataset.value);
    });
    // variant_json が存在する場合にマッチング（テーマ内にJSON埋め込みが必要）
    const variantJson = document.getElementById('variant-json');
    if (variantJson) {
      const variants = JSON.parse(variantJson.textContent);
      const matched = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedValues[i]; });
      });
      if (matched) {
        document.getElementById('variant-id').value = matched.id;
        const priceEl = document.getElementById('product-price');
        if (priceEl && matched.price) {
          const price = (matched.price / 100).toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' });
          priceEl.textContent = price + '（税込）';
        }
        const addBtn = document.querySelector('.btn-add-to-cart');
        if (addBtn) {
          addBtn.disabled = !matched.available;
          addBtn.textContent = matched.available ? 'カートに入れる' : '売り切れ';
        }
      }
    }
  }

  // --- カート数量変更 ---
  document.querySelectorAll('.qty-minus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const key = btn.dataset.key;
      const input = document.querySelector('.qty-input[data-key="' + key + '"]');
      if (input && parseInt(input.value) > 0) {
        input.value = parseInt(input.value) - 1;
        updateCartItem(key, parseInt(input.value));
      }
    });
  });

  document.querySelectorAll('.qty-plus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const key = btn.dataset.key;
      const input = document.querySelector('.qty-input[data-key="' + key + '"]');
      if (input) {
        input.value = parseInt(input.value) + 1;
        updateCartItem(key, parseInt(input.value));
      }
    });
  });

  document.querySelectorAll('.cart-item-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const key = btn.dataset.key;
      updateCartItem(key, 0);
    });
  });

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      // カート数更新
      const countEl = document.getElementById('cart-count');
      if (countEl) countEl.textContent = cart.item_count;
      // ページリロードで反映
      if (quantity === 0) location.reload();
    })
    .catch(function (err) { console.error('Cart update error:', err); });
  }

  // --- カートに追加（Ajax） ---
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = document.getElementById('variant-id').value;
      const addBtn = productForm.querySelector('.btn-add-to-cart');
      addBtn.textContent = '追加中...';
      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        addBtn.textContent = '追加しました ✓';
        setTimeout(function () {
          addBtn.textContent = 'カートに入れる';
          addBtn.disabled = false;
        }, 2000);
        // カート数更新
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        const countEl = document.getElementById('cart-count');
        if (countEl) countEl.textContent = cart.item_count;
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        addBtn.textContent = 'カートに入れる';
        addBtn.disabled = false;
      });
    });
  }

});
